import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const ActiveModelContext = createContext({
  activeModel: null,
  setActiveModel: () => {},
  clearActiveModel: () => {},
});

export const ActiveModelProvider = ({ children }) => {
  const [activeModel, setActiveModelState] = useState(null);

  const normalizeModelMetadata = (model) => {
    if (!model) return null;
    return {
      ...model,
      // Map only fields we actually get from backend
      normalizationUsed: model.normalizationUsed ?? model.metadata?.normalization ?? null,
      normalization_method: model.normalization_method 
        ?? model.metadata?.normalization_method 
        ?? model.preprocessing?.normalization_method 
        ?? null,
      training_timestamp: model.training_timestamp ?? model.metadata?.training_timestamp ?? null,
      scaler_path: model.scaler_path ?? model.metadata?.scaler_path ?? null,
    };
  };

  const setActiveModel = useCallback((model) => {
    setActiveModelState(normalizeModelMetadata(model));
  }, []);

  const clearActiveModel = useCallback(() => setActiveModelState(null), []);

  const value = useMemo(() => ({ activeModel, setActiveModel, clearActiveModel }), [activeModel, setActiveModel, clearActiveModel]);

  return (
    <ActiveModelContext.Provider value={value}>
      {children}
    </ActiveModelContext.Provider>
  );
};

export const useActiveModel = () => useContext(ActiveModelContext);

export default ActiveModelContext;


